import { render, staticRenderFns } from "./DashboardReport.vue?vue&type=template&id=15b3bd60&scoped=true&"
import script from "./DashboardReport.vue?vue&type=script&lang=js&"
export * from "./DashboardReport.vue?vue&type=script&lang=js&"
import style0 from "./DashboardReport.vue?vue&type=style&index=0&id=15b3bd60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b3bd60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
